// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMq from "vue-mq";
import VueMoment from 'vue-moment';
import VueCookies from 'vue-cookies'
import moment from 'moment'
import 'moment/locale/fr'
import 'moment/locale/nl-be'
import App from './App'
import store from "./store/";
import router from './router'
import SvgIcon from "@/components/SvgIcon";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { i18n } from "./locales/index.js";
import './validations/rules';
import Vue2TouchEvents from 'vue2-touch-events'
import ProgressionBar from '@/components/ProgressionBar'
import { addInterceptor } from '@/services/interceptors'
import vueHeadful from 'vue-headful';
import * as Filters from "@/filters";

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.productionTip = false

Vue.use(VueMoment, { moment });
Vue.use(Vue2TouchEvents)
Vue.use(VueCookies)

Vue.use(VueMq, {
  breakpoints: {
    mobile: 800,
    desktop: Infinity,
  }
});

Vue.component("SvgIcon", SvgIcon);
Vue.component("ProgressionBar", ProgressionBar);
Vue.component('vue-headful', vueHeadful);

Vue.mixin({
  filters: Filters
});

addInterceptor();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js